import { render, staticRenderFns } from "./brand_logo.vue?vue&type=template&id=77c6e19e&scoped=true&"
import script from "./brand_logo.vue?vue&type=script&lang=js&"
export * from "./brand_logo.vue?vue&type=script&lang=js&"
import style0 from "./brand_logo.vue?vue&type=style&index=0&id=77c6e19e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6e19e",
  null
  
)

export default component.exports